import { useState } from "react";
import { toast } from "sonner";
import { Loader2, Wand2 } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Field } from "@/components/admin/kit";
import { WellPicker } from "@/components/viewer/PumpjackLink";
import { api, errMsg } from "@/lib/api";
import { ASSET_TYPES } from "@/lib/industry";

const FIELDS = [["number", "Asset number"], ["producer", "Producer / operator"], ["area", "Area / field"], ["surface", "Surface LSD"], ["downhole", "Downhole LSD"], ["make", "Unit make"], ["size", "Unit size"], ["serial", "Serial number"]];

export function AssetFields({ h, setH }) {
  const [busy, setBusy] = useState(false);
  const a = h.asset || {};
  const setA = (patch) => setH((cur) => ({ ...cur, asset: { ...(cur.asset || {}), ...patch } }));
  const fill = async (well = h.pumpjack) => {
    if (!well?.surface) return toast.error("Pick the well first");
    setBusy(true);
    try {
      const { data } = await api.get("/admin/pumpjack/asset", { params: { surface: well.surface, downhole: well.downhole || "" } });
      setA(Object.fromEntries(Object.entries(data).filter(([k, v]) => v && !(h.asset || {})[k])));
      toast.success("Filled in from Pumpjack");
    } catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  const pick = (v) => { setH((cur) => ({ ...cur, pumpjack: v })); fill(v); };
  return (
    <div className="space-y-3" data-testid="asset-fields">
      <WellPicker value={h.pumpjack} onPick={pick} onClear={() => setH({ ...h, pumpjack: { surface: "", downhole: "", label: "" } })} title="1. Link the well (Pumpjack records)" />
      <div className="rounded-xl border p-3 space-y-3">
        <div className="flex items-center justify-between gap-2">
          <p className="text-sm font-semibold">2. Asset details (shown on the tour's opening screen and top bar)</p>
          <button type="button" onClick={() => fill()} disabled={busy} className="h-8 px-3 rounded-full border text-xs inline-flex items-center gap-1.5 shrink-0" data-testid="asset-fill">{busy ? <Loader2 className="w-3.5 h-3.5 animate-spin" /> : <Wand2 className="w-3.5 h-3.5" />}Fill from Pumpjack</button>
        </div>
        <div className="grid grid-cols-2 gap-3">
          <Field label="Asset type"><select className="w-full h-10 rounded-md border px-2 text-sm bg-white" value={a.type || ""} onChange={(e) => setA({ type: e.target.value })} data-testid="asset-type"><option value="">Choose…</option>{ASSET_TYPES.map((t) => <option key={t}>{t}</option>)}</select></Field>
          {FIELDS.map(([k, l]) => <Field key={k} label={l}><Input value={a[k] || ""} onChange={(e) => setA({ [k]: e.target.value })} data-testid={`asset-${k}`} /></Field>)}
          <Field label="Notes (access, hazards, contacts)" className="col-span-2"><Textarea rows={2} value={a.notes || ""} onChange={(e) => setA({ notes: e.target.value })} data-testid="asset-notes" /></Field>
        </div>
      </div>
    </div>
  );
}
